export const isLoading = state => state.attachmentsReducer.isLoading

export const attachments = state => state.attachmentsReducer.attachments

export const isSuccess = state => state.attachmentsReducer.isSuccess
